import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import * as moment from 'moment';
import { IHvDaten } from '../../models/hvdaten';
import { DateService } from '../../service/date.service';
import {ActivatedRoute} from '@angular/router';
import {getExpertMode} from '../../../shared/utils';

@Component({
  selector: 'app-vertragsbeginn-laufzeit',
  templateUrl: './vertragsbeginn-laufzeit.component.html',
  styleUrls: ['./vertragsbeginn-laufzeit.component.scss']
})
export class VertragsbeginnLaufzeitComponent implements OnInit {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Output()
  calculateRatePendingEvent = new EventEmitter<void>();

  beginndatumMinDate: Date;
  beginndatumMaxDate: Date;

  constructor(private dateService: DateService, private route: ActivatedRoute) {
    this.beginndatumMinDate = this.dateService.getVertragsBeginnDatumMinDate(getExpertMode(route));
    this.beginndatumMaxDate = this.dateService.getVertragsBeginnDatumMaxDate();
  }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      beginndatum: new UntypedFormControl('', Validators.required),
    });
  }

  ngOnInit(): void {
    this.onValueChanged();
  }

  get beginndatum() { return this.formGroup.get('beginndatum'); }

  returnZero(): number {
    return 0;
  }

  onValueChanged(): void {
      this.beginndatum.valueChanges.subscribe(() => {
      this.calculateRatePendingEvent.emit();
    });
  }

  getVertragsbeginnLaufzeit(): IHvDaten {
    return {
      Beginndatum: this.beginndatum.value,
    } as IHvDaten;
  }

  setVertragsbeginnLaufzeit(daten: IHvDaten): void {
    this.beginndatum.setValue(moment(daten.Beginndatum));
  }
}
